import { FieldHtmlNameUtil, HekateDisplayForm, Trans } from 'www-shared';
import { Ref } from 'vue';
import hekateBus from '../../../../../../bus';
import UnifiedSignupAgent from '../UnifiedSignupAgent';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import UnifiedSignupEmailType from '../session-info/UnifiedSignupEmailType';
import UnifiedSignupUtil from '../UnifiedSignupUtil';
import UnifiedSignupSessionInfo from '../session-info/UnifiedSignupSessionInfo';

export default abstract class AbstractStartSignupScreen extends AbstractSignupScreen {
  private submitText: string;

  constructor({
    sessionInfo,
    formDefinition,
    isBackButtonHidden,
    submitText,
  }: {
    sessionInfo: Ref<UnifiedSignupSessionInfo>,
    formDefinition: Ref<HekateDisplayForm>,
    isBackButtonHidden: Ref<boolean>,
    submitText: string,
  }) {
    super({ sessionInfo, formDefinition, isBackButtonHidden });
    this.submitText = submitText;
  }

  public getVisibleComponents() {
    const result = [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.firstName),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.lastName),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.email),
      }),
    ];
    return result;
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public async toNextScreen(): Promise<boolean> {
    if (UnifiedSignupUtil.isForcedScreenEnabled()) {
      this.sessionInfo.value.emailCheckCode = 200;
      this.sessionInfo.value.emailType = UnifiedSignupEmailType.genEmail;
      return true;
    }

    const email = this.getField(FieldHtmlNameUtil.email);
    const result = await UnifiedSignupAgent.emailCheck({
      email: email.val as string,
    });

    this.getField(FieldHtmlNameUtil.cadCheckStatusCode).val = result.emailCheckCode;
    this.sessionInfo.value.emailCheckCode = result.emailCheckCode;
    this.sessionInfo.value.emailCheckErrorReason = result.errorReason || '';
    this.sessionInfo.value.emailType = result.emailType;
    this.sessionInfo.value.isDiscoEligible = result.isDiscoEligible;
    this.isBackButtonHidden.value = false;
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  public async initWatchers(): Promise<void> {
    const formVariantField = this.getField('formVariant');

    // AB TESTING
    if (formVariantField.val === 'UssAbTest') {
      this.trackEvent('uss-ab-test');
      const email = this.getField(FieldHtmlNameUtil.email);
      email.label = Trans.byValue('Business Email');
    }

    hekateBus.dispatchEvent('lazy-load-images', {});
  }

  // eslint-disable-next-line class-methods-use-this
  public getNextButtonLabel(): string {
    return this.submitText || Trans.byValue('Get Started');
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 0;
  }

  // eslint-disable-next-line class-methods-use-this
  public isInitialScreen(): boolean {
    return true;
  }
}
